export interface ScoringCriteria {
  scale: string;
  score: number;
}

export interface ScoringFactor {
  name: string;
  criteria: ScoringCriteria[];
}

export interface WeightFactor {
  name: string;
  weight: number;
}

export const SCORING_CRITERIA_SECTIONS = [
  {
    id: 'criteria-section-1',
    rowGroupLabel: 'Scale',
    columns: [
      { key: 'nightDriving', label: 'Night Driving' },
      { key: 'continuousDriving', label: 'Continuous Driving' },
    ],
    rows: [
      { label: 'Equal to 0', values: { nightDriving: 5, continuousDriving: 5 } },
      { label: 'Above 0', values: { nightDriving: 0, continuousDriving: 0 } },
    ],
  },
  {
    id: 'criteria-section-2',
    rowGroupLabel: 'Scale',
    columns: [
      { key: 'phoneCalling', label: 'Phone Calling' },
      { key: 'smoking', label: 'Smoking' },
      { key: 'distraction', label: 'Distraction' },
      { key: 'hardBraking', label: 'Hard Braking' },
      { key: 'hardAcceleration', label: 'Hard Acceleration' },
    ],
    rows: [
      {
        label: 'Equal to 0',
        values: { phoneCalling: 10, smoking: 5, distraction: 10, hardBraking: 10, hardAcceleration: 5 },
      },
      {
        label: '1 to 2',
        values: { phoneCalling: 5, smoking: 3, distraction: 5, hardBraking: 3, hardAcceleration: 3 },
      },
      {
        label: '3 to 5',
        values: { phoneCalling: 3, smoking: 1, distraction: 3, hardBraking: 1, hardAcceleration: 1 },
      },
      {
        label: 'Above 5',
        values: { phoneCalling: 0, smoking: 0, distraction: 0, hardBraking: 0, hardAcceleration: 0 },
      },
    ],
  },
  {
    id: 'criteria-section-3',
    rowGroupLabel: 'Scale',
    columns: [
      { key: 'seatbelt', label: 'Seatbelt' },
      { key: 'forwardCollision', label: 'Forward Collision' },
      { key: 'vulnerableRoadUser', label: 'Vulnerable Road User' },
    ],
    rows: [
      { label: 'Equal to 0', values: { seatbelt: 5, forwardCollision: 10, vulnerableRoadUser: 10 } },
      { label: '1 to 2', values: { seatbelt: 3, forwardCollision: 5, vulnerableRoadUser: 5 } },
      { label: '3 to 5', values: { seatbelt: 1, forwardCollision: 3, vulnerableRoadUser: 3 } },
      { label: 'Above 5', values: { seatbelt: 0, forwardCollision: 0, vulnerableRoadUser: 0 } },
    ],
  },
  {
    id: 'criteria-section-4',
    rowGroupLabel: 'Scale',
    columns: [
      { key: 'overspeeding', label: 'Overspeeding' },
      { key: 'drowsiness', label: 'Drowsiness' },
    ],
    rows: [
      { label: 'Equal to 0', values: { overspeeding: 10, drowsiness: 15 } },
      { label: '1 to 5', values: { overspeeding: 5, drowsiness: 10 } },
      { label: '5 to 10', values: { overspeeding: 3, drowsiness: 5 } },
      { label: 'Above 10', values: { overspeeding: 0, drowsiness: 0 } },
    ],
  },
];

export const WEIGHT_SECTIONS = [
  {
    id: 'section-1',
    rowGroupLabel: '',
    columns: [
      { key: 'nightDriving', label: 'Night Driving' },
      { key: 'phoneCalling', label: 'Phone Calling' },
      { key: 'continuousDriving', label: 'Continuous Driving' },
      { key: 'overspeeding', label: 'Overspeeding' },
      { key: 'distraction', label: 'Distraction' },
    ],
    rows: [
      {
        label: 'Weight',
        values: {
          nightDriving: '0.05',
          phoneCalling: '0.1',
          continuousDriving: '0.05',
          overspeeding: '0.1',
          distraction: '0.1',
        },
      },
    ],
  },
  {
    id: 'section-2',
    rowGroupLabel: '',
    columns: [
      { key: 'hardBraking', label: 'Hard Braking' },
      { key: 'hardAcceleration', label: 'Hard Acceleration' },
      { key: 'drowsiness', label: 'Drowsiness' },
      { key: 'smoking', label: 'Smoking' },
      { key: 'seatbelt', label: 'Seatbelt' },
    ],
    rows: [
      {
        label: 'Weight',
        values: {
          hardBraking: '0.1',
          hardAcceleration: '0.05',
          drowsiness: '0.15',
          smoking: '0.05',
          seatbelt: '0.05',
        },
      },
    ],
  },
  {
    id: 'section-3',
    rowGroupLabel: '',
    columns: [
      { key: 'forwardCollision', label: 'Forward Collision' },
      { key: 'vulnerableRoadUser', label: 'Vulnerable Road User' },
    ],
    rows: [
      {
        label: 'Weight',
        values: {
          forwardCollision: '0.1',
          vulnerableRoadUser: '0.1',
        },
      },
    ],
  },
];
